export default "__VITE_PUBLIC_ASSET__c9ae888a__"